import axios from 'axios';

const list = (data) => axios.get('/safe/risk/list', data);
const save = (data) => axios.post('/safe/risk/save', data);


export default {
  list,
  save,

}


